<template>
<div>
  <btn @click="importSheets" type="danger">Réa REZO</btn>
  <modal v-model="show"
         :header="false"
         :backdrop="false"
         :keyboard="false"
         :footer="false">
    <h2>Import Réa REZO</h2>
    <div class="row">
      <div class="col-xs-12">
        <p>
          <input ref="fileInput" type="file" single>
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <steps :steps="iterator.steps" :stepStates="iterator.stepStates"></steps>
      </div>
    </div>
    <div v-if="completed">
      <btn @click="hide" type="default">Retour</btn>
    </div>
  </modal>
  <modal v-model="ufs.modal"
         :backdrop="false"
         :dismiss-btn="false"
         :keyboard="false"
         title="Association des Ufs">
    <div class="form-group"
         v-for="(u, k) in ufs.list"
         :key="`import-rezo-uf-${k}`">
      <label for="`import-rezo-uf-${k}-name`">Code service {{ u }}</label>
      <select v-model="ufs.result[u]"
              class="form-control">
        <option disabled value="">Uf associée</option>
        <option v-for="(v, j) in availableUfs"
                :value="v"
                :key="`import-rezo-uf-${k}-av-${j}`">
          {{ v.name }} ({{ v.typename }})
        </option>
      </select>
    </div>
    <collapse v-model="ufs.error.show">
      <alert type="danger">
        <strong>{{ ufs.error.title }}</strong>
        <p v-for="(e, i) in ufs.error.texts" :key="i">{{ e }}</p>
      </alert>
    </collapse>
    <div slot="footer">
      <btn @click="checkUfs" type="primary">Confirmer</btn>
    </div>
  </modal>
</div>
</template>
<script>
import StepIterator from '@/sui/tools/stepiterator'
import stepsViewer from '@/sui/components/steps'
import baseSteps from '@/components/sheets/import/impl/steps'
import impl from '@/components/sheets/import/impl/rezo'
import check from '@/components/sheets/import/impl/checkrezo'
import units from '@/sui/data/units'
import types from '@/sui/data/modules'
import assert from '@/sui/tools/assert'
import validator from '@/sui/components/sheet/validate/impl/validator'

check()

export default {
  name: 'sheets-import-rezo',
  props: {
    surveillance: {
      type: Object,
      required: true
    }
  },

  data: function () {
    const steps = [
      baseSteps.load(
        'Fichier Patient', 'Impossible de charger le fichier patient'
      ),
      baseSteps.transform(
        'Ajout des patients', 'Impossible de traiter le fichier patient',
        (count) => `${count} patients ajoutés avec succès.`,
        (vm, data, o, start, end) => {
          if (start === 0) {
            data.sheets = {}
            data.units = []
            vm.d = []
            const module = types.get(this.surveillance.year)['reaInfADI']
            assert.notNull(
              module,
              `selectReference: invalid sheet type (${this.module})`
            )
            vm.reference = module.sheets.edit
          }
          for (let i = start; i !== end; ++i) {
            const patient = o[i]
            const transformed = impl.createPatient(patient)
            data.sheets[`${transformed.rezoId}`] = transformed
            if (data.units.indexOf(patient.codserv) === -1) {
              data.units.push(patient.codserv)
            }
          }
        }
      ),
      baseSteps.load(
        'Fichier CVC', 'Impossible de charger le fichier CVC'
      ),
      baseSteps.transform(
        'Ajout des CVCs', 'Impossible de traiter le fichier CVC',
        (count) => `${count} CVCs ajoutés avec succès.`,
        (vm, data, o, start, end) => {
          for (let i = start; i !== end; ++i) {
            const transformed = impl.createCVC(o[i])
            if (transformed == null) {
              continue
            }
            const sheet = data.sheets[`${transformed.rezoId}`]
            transformed.covidStatus = sheet.covidStatus
            sheet.catheters.push(transformed)
          }
        }
      ),
      baseSteps.load(
        'Fichier infections', 'Impossible de charger le fichier infections'
      ),
      baseSteps.transform(
        'Ajout des infections', 'Impossible de traiter le fichier infections',
        (count) => `${count} infections ajoutées avec succès.`,
        (vm, data, o, start, end) => {
          for (let p = start; p !== end; ++p) {
            const i = o[p]
            // Si BLC, épisode saisi également en tant que BAC pour Rea-Rezo
            if (i.sitein === 2 && [3, 4, 5].indexOf(i.pein) === -1) {
              const transformed = impl.createBacteriemia(i)
              const sheet = data.sheets[transformed.rezoId]
              transformed.covidStatus = sheet.covidStatus
              sheet.bacteriemia = 1
              sheet.bacteremias.push(transformed)
            }
            if (i.sitein === 1) {
              const transformed = impl.createPneumopathy(i)
              const sheet = data.sheets[transformed.rezoId]
              transformed.covidStatus = sheet.covidStatus
              sheet.pneumopathy = 1
              sheet.pneumopathies.push(transformed)
            }
          }

          for (let i in data.sheets) {
            const sh = data.sheets[i]
            vm.d.push({ f: sh, t: 'reaInfADI', y: this.surveillance.year })
          }
        }
      ),
      {
        title: 'Sélection des Ufs',
        run: function (vm, data, iteration) {
          if (iteration === 0) {
            vm.showUfsModal(data.units)
          }

          if (!vm.ufs.modal && !vm.ufs.error.show) {
            for (let i in data.sheets) {
              const sheet = data.sheets[i]
              const unit = vm.ufs.result[sheet.codserv.toString()]
              sheet.unitType = unit.type
              sheet.uf = unit.name
            }
            return { end: true, success: true }
          }
          return { end: !vm.ufs.modal, success: !vm.ufs.error.show }
        },

        setError: function (e) {
          return `Erreur lors de l'association des Ufs avec les codes services : ${e}.`
        }
      },
      validator.steps.validate(vm => vm.d, true),
      baseSteps.purge('reaInfADI'),
      baseSteps.insert('reaInfADI', 'rezo')
    ]

    return {
      show: false,
      iterator: new StepIterator(steps),
      ufs: {
        modal: false,
        result: {},
        list: [],
        error: {
          show: false,
          texts: [],
          title: ''
        }
      }
    }
  },

  computed: {
    unitTypes: function () {
      return units['2023'].adRea
    },

    completed: function () {
      return this.iterator.completed
    },

    availableUfs: function () {
      if (this.surveillance == null) {
        return []
      }

      const result = []
      const rea = this.surveillance.modules.reaInfADI.ufs
      rea.forEach(
        (r) => {
          const typename = this.unitTypes.find((e) => e.index === r.ufType).code
          result.push({ type: r.ufType, typename: typename, name: r.name })
        }
      )
      return result
    }
  },

  watch: {
    show: function (value) {
      if (!value) {
        this.iterator.reset()
      }
    }
  },

  methods: {
    importSheets: function () {
      this.iterator.start(this)
      this.show = true
    },

    hide: function () {
      this.show = false
    },

    setError: function (title, texts) {
      this.ufs.error.show = true
      this.ufs.error.title = title
      this.ufs.error.texts = texts
    },

    checkUfs: function () {
      const ufs = []
      for (let i in this.ufs.list) {
        const s = this.ufs.list[i]
        const r = this.ufs.result[s]
        if (r == null) {
          this.setError(
            'Attention !',
            [ 'Toutes les codes services doivent être associés.' ]
          )
          return
        } else if (ufs.indexOf(r) !== -1) {
          this.setError(
            'Attention !',
            [ 'Une Uf ne peut être utilisée que pour un seul code service.' ]
          )
          return
        } else {
          ufs.push(r)
        }
      }
      this.ufs.modal = false
    },

    showUfsModal: function (units) {
      this.ufs.error.show = false
      this.ufs.list = units
      this.ufs.result = []
      this.ufs.modal = true
    }
  },

  components: {
    'steps': stepsViewer
  }
}
</script>
<style lang="less" scoped>
</style>
